// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles-module__spinner___1qON2","load8":"styles-module__load8___1mMLM","active":"styles-module__active___cnr_d"};